import { StickyNotes } from "./components/StickyNotes";
import { maintainPermioSession } from "./api/session";
import { AdminMfaDialog } from "./components/AdminMfaDialog";
import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { useAuthStore } from "./store/auth.store";
import { LoadingScreen } from "./components/LoadingScreen";

function App() {
  const bootstrapFinished = useAuthStore((state) => state.bootstrapFinished);

  // AppProviders initialise la session ; App est remontée à chaque changement d'école.
  useEffect(maintainPermioSession, []);

  if (!bootstrapFinished) {
    return (
      <>
        <AdminMfaDialog />
        <LoadingScreen message="Initialisation..." />
      </>
    );
  }

  return (
    <>
      <AdminMfaDialog />
      <Suspense fallback={<LoadingScreen message="Chargement..." />}>
        <RouterProvider router={router} />
      </Suspense>
      <StickyNotes
        onNavigate={(href) => {
          void router.navigate(href);
        }}
      />
    </>
  );
}

export default App;
